export default __webpack_public_path__ + "static/media/book2.10a22397.gif";